<!-- Divider -->
<div
    class="platform-vertical-navigation-item-wrapper divider"
    [ngClass]="item.classes?.wrapper"></div>
